// Bypass access is now handled server-side in the check-subscription edge function.
// This file is kept for backward compatibility but always returns false.
// The server checks bypass emails and returns subscribed: true for those users.

export const isBypassedEmail = (_email: string | undefined | null): boolean => {
  return false;
};
